import { addWSIMiniNavigationOverlayCss, loadWSIData, } from '../../../utilities/WSIUtilities.js';
import { getGenericViewportWSIDisplaySet } from '../genericViewportDisplaySetAccess.js';
export class DefaultWSIDataProvider {
    async load(dataId) {
        const dataSet = this.getDataSet(dataId);
        if (!dataSet) {
            throw new Error(`[WSIViewport] No registered WSI dataset metadata for ${dataId}`);
        }
        if (dataSet.options.miniNavigationOverlay !== false) {
            addWSIMiniNavigationOverlayCss();
        }
        const loadedData = await loadWSIData({
            imageIds: dataSet.imageIds,
            client: dataSet.options.webClient,
        });
        return {
            id: dataId,
            type: 'wsi',
            imageIds: dataSet.imageIds,
            client: dataSet.options.webClient,
            volumeImages: loadedData.volumeImages,
            metadataDicomweb: loadedData.metadataDicomweb,
            metadata: loadedData.metadata,
            frameOfReferenceUID: loadedData.frameOfReferenceUID,
            imageURISet: loadedData.imageURISet,
        };
    }
    getDataSet(dataId) {
        const registered = getGenericViewportWSIDisplaySet(dataId);
        if (!registered) {
            return;
        }
        return registered;
    }
}
